module.exports = __webpack_public_path__ + "assets/9e3368c2918931083f3cf22931606dd9.svg";